import { Footer } from "../../../Footer/Footer"
import { HerosectionsAll } from "../../../HeroSectionAll/HerosectionsAll"
import { Header } from "../../../IndexPage/Header/Header"


export const Seminars = () => {
    return (
        <>
            <div className="container-fluid">
                <div className="row " style={{ background: '#fff' }} onLoad={() => window.scrollTo(0, 0)}>
                    <div className="col-12">
                        <Header actives="Seminars" />
                        <HerosectionsAll ScreenName="Seminars" ScreenSearch="Lectures" />

                        {/* <div className="row col-lg-9 mx-auto p-2 p-lg-5 my-5">
                            <div className="col-12 p-lg-5 faint p-4" style={{ textAlign: 'justify' }}>
                                <h5 className="fw-bold gray_color pb-3">Seminars</h5>
                                <p>Marine insurance includes interconnected topics and hence one - line solution is very rare.
                                    <br />
                                    There is a need for brainstorming discussions in the presence of industry experts. We arrange workshops and seminars that encourage lateral thinking through interactive participation. </p>
                            </div>
                        </div> */}


                        <div className="row col-lg-11 mx-auto mt-3 mb-0 ">
                            <div className="row justify-content-center">
                                <div className="text-center py-3 rounded"
                                    style={{
                                        backgroundColor: '#16374e',
                                        width: '100%',
                                        // height: '450px'
                                    }}
                                >
                                    <h5 className="fw-bold text-white pb-2 ">Upcoming Seminars</h5>
                                    {/* <img
                                        src="Static/Assets/Img/Webinars/seminarimage.jpeg"
                                        alt="MILSO July 2026 Seminar"
                                        className="img-fluid rounded"
                                        style={{
                                            width: '100%',
                                            height: 'auto',
                                            boxShadow: '10px 10px #cd9e53'
                                        }}
                                    /> */}
                                    <iframe
                                        src="Static/Assets/Img/Seminars/Milso_July_2026_seminar-1-2-pages-2.pdf#zoom=50"
                                        title="MILSO January 2026 Seminar"
                                        style={{
                                            width: '100%',
                                            // height: '50vh',
                                            minHeight: '600px',
                                            border: 'none',
                                            boxShadow: '10px 10px #cd9e53'
                                        }}
                                    />
                                </div>
                            </div>
                        </div>


                        <div className="container mt-3 p-4 rounded shadow-sm" style={{ backgroundColor: "#f8f9fa" }}>


                            <div className="row align-items-center mt-3">

                                {/* Left Side Content */}
                                <div className="col-md-7">
                                    <h2 className="fw-bold text-primary">Seminar Series:
                                        {/* <br />Fundamentals of Marine Hull & Machinery Insurance */}
                                    </h2>
                                    {/* <p className="lead mt-3">Unlock the World of Marine Insurance — One Session at a Time</p> */}
                                    <p>
                                        For interconnected topics like Marine insurance one line solution is very rare. So we arrange brainstorming discussions in the presence of industry experts that encourage lateral thinking.
                                    </p>

                                    <h2 className="fw-bold text-primary">Individual / Corporate Trainings:
                                        {/* <br />Fundamentals of Marine Hull & Machinery Insurance */}
                                    </h2>
                                    {/* <p className="lead mt-3">Unlock the World of Marine Insurance — One Session at a Time</p> */}
                                    <p>
                                        We customised training sessions based on training need analysis techniques like fish bone analysis, five why technique etc.
                                        <br />
                                        We use blended training methods in which students /trainees learn through both electronic / online media and conventional face-to-face interaction.
                                    </p>

                                </div>

                                {/* Right Side Image (Optional or Themed Graphic) */}
                                <div className="col-md-5 col-lg-5 text-center mt-4 mt-md-0">
                                    <img src="Static/Assets/Img/Seminar_Img.jpeg" alt="Marine Insurance Webinar" className="img-fluid rounded shadow-sm ms-5" />
                                    {/* If image not ready, use placeholder: */}
                                    {/* <div className="bg-secondary rounded text-white p-5">Webinar Banner Here</div> */}
                                </div>

                            </div>

                        </div>

                        <Footer />
                    </div>
                </div>
            </div>

        </>
    )
}
